import { render, staticRenderFns } from "./StockVue.vue?vue&type=template&id=27162e06&"
import script from "./StockVue.vue?vue&type=script&lang=js&"
export * from "./StockVue.vue?vue&type=script&lang=js&"
import style0 from "./StockVue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports